{
    "welcomeTo": "Welcome to",
    "platformForEducationalInstitutions": "Platform for Educational Institutions",
    "loginQuote": "The best and most beautiful things in the world cannot be seen or even touched - they must be felt with the heart.",
    "loginQuoteAuthor": "- Helen Keller",
    "help": "Help?",
    "login": "Login",
    "loginWithYourCredentials": "Login with your credentials",
    "usernameOrEmailId": "Username/Email id",
    "password": "Password",
    "forgotPassword": "Forgot password ?",
    "getOTP": "Get OTP",
    "loginWithPassword": "Login with password",
    "or": "or",
    "enterYourSchoolURL": "Enter your School URL",
    "notRegistered": "Not registered?",
    "register": "Register",
    "loginWithOTP": "Login With OTP",
    "otpVerification": "OTP Verification",
    "otpVerificationMessage": "Please enter the OTP sent to the registered mail id.",
    "resendOtp": "Resend OTP",
    "sec": "sec",
    "in": "in",
    "resendAttempts": " attempts left",
    "errorMessage": "Oops ! Something went wrong",
    "error": "error",
    "success": "success",
    "localhost": "localhost",
    "localHostLogin": "http://registration.localhost:4200",
    "bluewingsRegisterUrl": "registration.bluewings.in",
    "localHostRegisterWizard": "http://registration.localhost:4200/#/institute-onboard/step/1",
    "bluewingsRegisterUrlWizard": "registration.bluewings.in/#/institute-onboard/step/1",
    "url": "URL",
    "bluewingsIn": ".bluewings.in",
    "continue": "Continue",
    "forgotSchoolURL": "Forgot School URL?",
    "loginWithEmailId": "Login with email id",
    "errorMessageForUrl": "Please enter a valid school url",
    "enterUrl": "Enter URL",
    "enterYourUsernameOrEmailId": "Enter your username/email id",
    "enterYourPassword": "Enter your password",
    "errorMessageForUserOrEmailAddress": "Please enter a valid user name or email address",
    "backspace": "Backspace",
    "localHostPortPath": ":4200/#/login",
    "bluewingsPortPathLogin": "/#/login",
    "localHostLoginUrl": "http://app.localhost:4200/#/login",
    "prodHostLoginUrl": "//app.bluewings.in/#/login",
    "currency": "currency",
    "schoolSuspendedMessage": "School is suspended please contact admin",
    "localHostDashboardPath": ":4200/#/dashboard",
    "bluewingsDashboardPath": "/#/dashboard",
    "bluewingsFranchiseDashboardPath": "/#/franchise/dashboard",
    "loginMode": "loginMode",
    "WEB_ADMIN": "WEB_ADMIN",
    "usertoken": "usertoken",
    "schoolinfo": "schoolinfo",
    "adminType": "adminType",
    "feesModuleSettings": "feesModuleSettings",
    "isFranchise": "isFranchise",
    "fkFranchiseId": "fkFranchiseId",
    "schoolDomain": "schoolDomain",
    "adminPermissionlist": "adminPermissionlist",
    "equalTo": "=",
    "bluewingsSchoolDetailsPath": "#/institute-onboard/step/1",
    "bluewingsSchoolUnderVerificationPath": "#/institute-under-verification",
    "schoolVerification": "schoolVerification",
    "localSchoolDetailsPath": "localhost:4200/#/institute-onboard/step/1",
    "appBluewingsIn": "app.bluewings.in",
    "underVerification": "underVerification",
    "step1": "step1",
    "domainBluewingsSchoolDetailsPath": ".bluewings.in/#/institute-onboard/step/1",
    "domainBluewingsSchoolUnderVerificationPath": ".bluewings.in/#/institute-under-verification",
    "domainBluewingsFranchiseDashboardPath": ".bluewings.in/#/franchise/dashboard",
    "domainBluewingsFranchieDashboardPath": ".bluewings.in/#/dashboard",
    "schoolAddress": "schoolAddress",
    "phoneNumber": "phoneNumber",
    "schoolEmailId": "schoolEmailId",
    "schoolName": "schoolName",
    "countryCode": "countryCode",
    "schoolImage": "schoolImage",
    "sessionErrorCode": "10006",
    "pleaseLogin": "please login",
    "loginPath": "/login",
    "SessionExpiredMessage": "Session Expired, Login Again",
    "errorMessageForPassword": "Please enter a valid password",
    "resetPassword" : "Reset Password",
    "newPassword" : "New Password",
    "confirmPassword" : "Confirm Password",
    "enterNewPassword" : "Enter new password",
    "enterConfirmPassword" :"Enter Confirm password",
    "ForgotPassword" : "Forgot Password",
    "createNewPassword":"Create your new password",
    "verifyOtpAndSetNewPassword":"Please verify OTP and set new password",
    "sendOtp" : "Send OTP",
    "submit"  : "Submit",
    "goBack" : "Go back",
    "staffLogin":"Staff Login",
    "mobileNumberForStaff" : "Enter mobile number",
    "mobileNumber":"Mobile Number",
    "adminLogin" : "Admin Login ",
    "switchTo" :"Switch to",
    "staffName" :"staffName",
    "emptyMobileNumber" :"Mobile number should not be empty",
    "emptyMobileNumberOrEmail" :"Mobile number or email should not be empty",
    "emptyPassword" :"Password should not be empty",
    "invalidStaffCredentials" :"The mobile number, email or password you entered is incorrect. If you need help, please contact the administrator.",
    "onlyNumberAllowed" : "Please enter only numbers.",
    "invalidMobileOrEmail" : "Please enter a valid mobile number or email address."
}